import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';
import type { Estimate } from '@/types/estimate';

export function useReviseEstimate() {
  const queryClient = useQueryClient();

  return useApiMutation<Estimate, string>({
    mutationFn: (id) => apiPost<Estimate>(operationsClient, opsEstimateEndpoints.revise(id)),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(data.id) });
      toast.success(`Revision #${data.revisionNumber} created`);
    },
  });
}
